<script>
  import SvelteMarkdown from 'svelte-markdown'
  import { styles } from '../../../helper'
  export let selection
</script>

<div class="preconditions-abstract" use:styles={{ itemColor: selection.color }} >
  <SvelteMarkdown source={selection.text} />
</div>

<style lang="scss" global>
  .preconditions-abstract {
    padding: 20px;

    place-self: start end;

    font: 20px Arvo, serif;
    text-align:left;

    width: 10em;
    color: #c8c8c8;
    font-size: 16px;
    @include media-1col-only {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      width: auto;
    }

    h3 {
      color: var(--itemColor);
    }

    em {
      color: var(--itemColor);
      margin-right: 1ex;
      display: inline-flex;
    }

    p em {
      display: block;
      margin-bottom: 0.5ex;
    }

    h4, p {
      border-top: solid 1px currentColor;
      margin-top: 1ex;
      padding-top: 1ex;

    }
  }
</style>